import assetStatusService from "../../../../services/assetService/assetStatusService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETSTATUSES } from "../../../../utils/constants";
import { AssetStatusInterface } from "../../../../models/AssetModel/AssetStatus";

const useAssetStatuses = (page: number, pageSize: number) =>
  useQuery<AssetStatusInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETSTATUSES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetStatusService.GetAll(page, pageSize),
    initialData: [],
  });

export default useAssetStatuses;
